// 版本升级校验

// import { MessageBox } from 'element-ui';


import { showConfirmDialog } from 'vant';
import { indexPage } from '@/config';

let version_no = void 0;
// 请求html地址
const fetchUrl = indexPage;

const WAIT_TIME = 10 * 1000; // 版本获取间隔时间，每WAIT_TIME请求一次
// message弹窗
let isMessage = false;

const setVersionNo = (versionNo) => {
  version_no = versionNo;
};

const getVersionNo = () => {
  return version_no;
};

/**
 * 清空缓存，重新请求
 * @param {string} newVersion
 */
const refreshCache = (newVersion) => {
  // 先请求一次页面，设置不缓存，获取最新的html
  fetch(`${fetchUrl}?time=${new Date().getTime()}`, { cache: 'no-store' }).finally(() => {
    isMessage = false;
    setVersionNo(newVersion);
    // 刷新页面
    window.location.reload();
  });
};

// 定义无需更新的地址数组
const excludeUrls = ['/share']; // 可以添加多个地址

/**
 * 判断当前地址是否在排除列表中
 * @returns {boolean} 如果地址在排除列表中，返回true，否则返回false
 */
const isExcludedUrl = () => {
  const currentHash = window.location.hash;
  return excludeUrls.some(url => currentHash.startsWith(url));
};

/**
 * 请求页面，获取版本并比对
 */
const fetchNewVersion = () => {
  // 检查当前地址是否在排除列表中
  if (isExcludedUrl()) {
    return;
  }
  // 在 js 中请求首页地址不会更新页面
  fetch(`${fetchUrl}?time=${new Date().getTime()}`, { cache: 'no-store' })
    .then((res) => res.text())
    .then((text) => {
      const oldVersion = getVersionNo();
      const el = document.createElement('html');
      el.innerHTML = text;
      const htmlMeta = el.querySelector('meta[name="version_no"]');
      if (!htmlMeta) return;
      const newVersion = htmlMeta.getAttribute('content');
      if (newVersion !== oldVersion && !isMessage) {
        isMessage = true;
        if (!localStorage.getItem('App-Token')) {
          refreshCache(newVersion);
        }else {
          showConfirmDialog({
            title: '版本更新',
            message: '检测到新版本，点击刷新按钮以更新页面。',
            cancelButtonText: '稍后',
            confirmButtonText: '刷新'
          })
            .then(() => {
              refreshCache(newVersion);
            })
            .catch(() => {
              // on cancel
              setInterval(() => {
                isMessage = false;
                fetchNewVersion();
              }, 5 * 60 * 1000);
            });
        }

      }
    })
    .catch((err) => {
      // eslint-disable-next-line no-console
      console.log('[ err ] >', err);
    });
};
fetchNewVersion();

setInterval(() => {
  fetchNewVersion();
}, WAIT_TIME);

/**
 * 设置当前版本号
 */
const getCurrentVersionNo = () => {
  const htmlMeta = document.querySelector('meta[name=\'version_no\']');
  // 获取content的版本号
  const versionNo = htmlMeta?.getAttribute('content');
  setVersionNo(versionNo);
};

getCurrentVersionNo();